// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../static/hero-img.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../static/old-way.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../static/new-way.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../static/inspection-mobile.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin:0;
    padding:0;
    box-sizing:border-box;
    font-family:Arial, sans-serif;
}

body{
    background:#f8fafc;
    color:#1e293b;
    line-height:1.6;
    opacity: 0;
    animation: fastFade 0.3s ease-out forwards;
}

@keyframes fastFade {
  to {
    opacity: 1;
  }
}

/* HEADER */

.header{
    background:#0f172a;
    color:#fff;
    padding:20px 8%;
    display:none;
    justify-content:space-between;
    align-items:center;
    position:sticky;
    top:0;
    z-index:999;
}

.header-mobile{
    position:sticky;
    top:0;
    background:#fff;
    padding:14px 18px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    box-shadow:0 2px 10px;
    z-index:999;
}

.logo{
    font-size:32px;
    font-weight:bold;
}

.logo span{
    color:#dc2626;
}

nav ul{
    display:flex;
    list-style:none;
    gap:30px;
}

nav a{
    color:white;
    text-decoration:none;
    font-weight:600;
}

nav a:hover{
    color:#dc2626;
}

/* HERO */

.hero{
  display:none;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  opacity: 0.35; /* Blurs/fades ONLY the image */
  z-index: -1;   /* Pushes it behind the text */
}

.hero-mobile{position:relative;padding:26px 20px 40px;}
.hero-mobile::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.35; /* Blurs/fades ONLY the image */
  z-index: -1;   /* Pushes it behind the text */
}
.hero-mobile h1{font-size:2.4rem;line-height:1.05;color:var(--navy)}
.hero-mobile p{margin:16px 0 24px;font-size:1rem}

.btns-mobile{display:flex;gap:12px;flex-wrap:wrap}

.hero-left{
    flex:1;
    text-align: center;
}

.hero-left h1{
    font-size:60px;
    line-height:1.1;
    margin-bottom:20px;
}

.hero-left p{
    font-size:20px;
    margin-bottom:30px;
}

.hero-buttons{
    display:flex;
    justify-content: center;
    gap:20px;
}

a.btn{
    padding:15px 35px;
    border-radius:8px;
    text-decoration:none;
    font-weight:bold;
    transition:.3s;
}

a.btn-mobile{
    padding:14px 18px;border-radius:12px;text-decoration:none;font-weight:700;text-align:center;flex:1;
}

a.btn-primary{
    background:#dc2626;
    color:white;
}

a.btn-primary:hover{
    background:#b91c1c;
}

a.btn-secondary{
    border:2px solid #0f172a;
    background:transparent;
    color:#0f172a;
}

a.btn-secondary:hover{
    background:#0f172a;
    color:white;
}

.hero-right{
    flex:1;
}

.hero-right img{
    width:100%;
    border-radius:20px;
    box-shadow:0 20px 40px rgba(0,0,0,.15);
}

/* SECTION */

section{
    padding:40px 2%;
}

.section-title{
    text-align:center;
    font-size:clamp(1.125rem, 4vw, 1.875rem);
    margin-bottom:20px;
}

/* COMPARISON */

.comparison{
    display:grid;
    grid-template-columns:1fr;
    gap:30px;
}

.comparison-section{
    display:none;
}

.comparison-section-mobile{
    display:block;
}

.box{
    padding:40px;
    border-radius:20px;
    text-align:center;
    overflow: hidden;
}

.old-way{
  position: relative;
}

.old-way::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  opacity: 0.15; /* Blurs/fades ONLY the image */
  z-index: -1;   /* Pushes it behind the text */
}

.new-way{
  position: relative;
}

.new-way::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-position: center;
  opacity: 0.35; /* Blurs/fades ONLY the image */
  z-index: -1;   /* Pushes it behind the text */
}

.box h3{
    margin-bottom:20px;
    font-size:28px;
}

.box {
    font-weight:600;
}

/* BENEFITS */

.benefit-section{
    display:none;
}

.cards{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
    gap:30px;
}

.card{
    display: none;
    background:white;
    padding:40px;
    border-radius:20px;
    text-align:center;
    box-shadow:0 10px 25px rgba(0,0,0,.08);
}

.card-mobile{background:#fff;border-radius:18px;padding:22px;box-shadow:0 8px 24px rgba(0,0,0,.08);margin-bottom:18px}

.card h3{
    margin:20px 0;
}

/* PROCESS */

.how-it-works{
    margin-bottom:10px;
}
.steps{
    display:grid;
    grid-template-columns:repeat(5,1fr);
    gap:20px;
}

.step{
    background:white;
    padding:30px;
    text-align:center;
    border-radius:20px;
    box-shadow:0 5px 15px rgba(0,0,0,.08);
}

.step-mobile{
  display:flex;
  align-items:center;
  gap:16px;
  margin:16px 0
}

.num-mobile {
  width:42px;
  height:42px;
  border-radius:50%;
  background:#d62828;
  color:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
}


.whatsapp-section{
    display:flex;
    justify-content:end;
    width:100%;
    align-items:center;
}

a.whatsapp-box{
    position:relative;
    margin-bottom:12px;
    max-width:300px;
    display:flex;
    align-items:center;
    background:#25D366;
    animation: breathe 1s ease-in-out infinite;
}

@keyframes breathe{

    0%{
        transform:scale(1);
        box-shadow:0 0 0 rgba(37,211,102,.4);
    }

    50%{
        transform:scale(1.1);
        box-shadow:0 12px 35px rgba(37,211,102,.45);
    }

    100%{
        transform:scale(1);
        box-shadow:0 0 0 rgba(37,211,102,.4);
    }

}

.number{
    width:60px;
    height:60px;
    background:#dc2626;
    color:white;
    border-radius:50%;
    display:flex;
    justify-content:center;
    align-items:center;
    margin:0 auto 20px;
    font-size:24px;
    font-weight:bold;
}

/* INSPECTION */

.inspection{
    display:none;
    background:#0f172a;
    color:white;
    border-radius:30px;
    padding:30px;
}

.inspection-mobile{

    display:flex;
    flex-direction:column;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    aspect-ratio: 3 / 4;
    background-size: contain;
    color:white;
    padding:45px;

    justify-content:space-between;
    align-items:end;
    gap:40px;

}

.inspection-mobile p{

    font-size:12px;
    line-height:1.8;
    color:#d1d5db;

}

.inspection-list{
    display:grid;
    grid-template-columns:1fr;
    gap:20px;
    margin-top:40px;
}

.inspection-item{
    background:rgba(255,255,255,.08);
    padding:20px;
    border-radius:10px;
}

/* CTA */

.cta{
    display:none;
    background:#dc2626;
    color:white;
    text-align:center;
    border-radius:30px;
}

.cta h2{
    font-size:50px;
    margin-bottom:20px;
}

/* FOOTER */

footer{
    background:#0f172a;
    color:white;
    text-align:center;
    padding:40px;
    margin-top:40px;
}

/* MOBILE */

@media(min-width:900px){
  section{
    padding:90px 8%;
  }
  .section-title{
    text-align:center;
    font-size:42px;
    margin-bottom:40px;
  }
  .header{
    display:flex;
  }
  .header-mobile{
    display:none;
  }
  .hero{
    display:flex;
    min-height:90vh;
    align-items:center;
    justify-content:space-between;
    padding:80px 8%;
    gap:60px;
  }
  .hero-mobile{
    display:none;
  }
  .comparison-section{
    display:block;
  }
  .comparison-section-mobile{
    display:none;
  }
  .comparison{
    grid-template-columns:1fr 1fr;
  }
  .inspection-list{
    grid-template-columns:repeat(2,1fr);
  }
  .benefit-section{
    display:block;
  }
  .benefit-section-mobile{
    display:none;
  }
  .card{
    display:block;
  }
  .card-mobile{
    display:none;
  }
  .inspection{
    display:block;
  }
  .inspection-mobile{
    display:none;
  }
  .cta{
    display:block
  }
  footer{
    margin-top:80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Main/css/Main.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,UAAU;IACV,0CAA0C;AAC9C;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,KAAK;IACL,WAAW;AACf;;AAEA;IACI,eAAe;IACf,KAAK;IACL,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,SAAS;;AAET;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yDAAsD;EACtD,sBAAsB;EACtB,aAAa,EAAE,+BAA+B;EAC9C,WAAW,IAAI,8BAA8B;AAC/C;;AAEA,aAAa,iBAAiB,CAAC,sBAAsB,CAAC;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yDAAsD;EACtD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa,EAAE,+BAA+B;EAC9C,WAAW,IAAI,8BAA8B;AAC/C;AACA,gBAAgB,gBAAgB,CAAC,gBAAgB,CAAC,iBAAiB;AACnE,eAAe,kBAAkB,CAAC,cAAc;;AAEhD,aAAa,YAAY,CAAC,QAAQ,CAAC,cAAc;;AAEjD;IACI,MAAM;IACN,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,eAAe,CAAC,iBAAiB,CAAC,MAAM;AACtG;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,YAAY;;AAEZ;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA,eAAe;;AAEf;IACI,YAAY;IACZ,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yDAAqD;EACrD,sBAAsB;EACtB,aAAa,EAAE,+BAA+B;EAC9C,WAAW,IAAI,8BAA8B;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,yDAAqD;EACrD,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa,EAAE,+BAA+B;EAC9C,WAAW,IAAI,8BAA8B;AAC/C;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,aAAa;;AAEb;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,wDAAwD;IACxD,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA,aAAa,eAAe,CAAC,kBAAkB,CAAC,YAAY,CAAC,qCAAqC,CAAC,kBAAkB;;AAErH;IACI,aAAa;AACjB;;AAEA,YAAY;;AAEZ;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,mCAAmC;IACnC,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;;IAEI;QACI,kBAAkB;QAClB,oCAAoC;IACxC;;IAEA;QACI,oBAAoB;QACpB,2CAA2C;IAC/C;;IAEA;QACI,kBAAkB;QAClB,oCAAoC;IACxC;;AAEJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,eAAe;;AAEf;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;IACrB,oIAA0I;IAC1I,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,YAAY;;IAEZ,6BAA6B;IAC7B,eAAe;IACf,QAAQ;;AAEZ;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,aAAa;;AAEjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;AACtB;;AAEA,QAAQ;;AAER;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA,WAAW;;AAEX;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,mCAAmC;EACrC;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["*{\r\n    margin:0;\r\n    padding:0;\r\n    box-sizing:border-box;\r\n    font-family:Arial, sans-serif;\r\n}\r\n\r\nbody{\r\n    background:#f8fafc;\r\n    color:#1e293b;\r\n    line-height:1.6;\r\n    opacity: 0;\r\n    animation: fastFade 0.3s ease-out forwards;\r\n}\r\n\r\n@keyframes fastFade {\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* HEADER */\r\n\r\n.header{\r\n    background:#0f172a;\r\n    color:#fff;\r\n    padding:20px 8%;\r\n    display:none;\r\n    justify-content:space-between;\r\n    align-items:center;\r\n    position:sticky;\r\n    top:0;\r\n    z-index:999;\r\n}\r\n\r\n.header-mobile{\r\n    position:sticky;\r\n    top:0;\r\n    background:#fff;\r\n    padding:14px 18px;\r\n    display:flex;\r\n    justify-content:space-between;\r\n    align-items:center;\r\n    box-shadow:0 2px 10px;\r\n    z-index:999;\r\n}\r\n\r\n.logo{\r\n    font-size:32px;\r\n    font-weight:bold;\r\n}\r\n\r\n.logo span{\r\n    color:#dc2626;\r\n}\r\n\r\nnav ul{\r\n    display:flex;\r\n    list-style:none;\r\n    gap:30px;\r\n}\r\n\r\nnav a{\r\n    color:white;\r\n    text-decoration:none;\r\n    font-weight:600;\r\n}\r\n\r\nnav a:hover{\r\n    color:#dc2626;\r\n}\r\n\r\n/* HERO */\r\n\r\n.hero{\r\n  display:none;\r\n}\r\n\r\n.hero::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background-image: url('../../../static/hero-img.webp');\r\n  background-size: cover;\r\n  opacity: 0.35; /* Blurs/fades ONLY the image */\r\n  z-index: -1;   /* Pushes it behind the text */\r\n}\r\n\r\n.hero-mobile{position:relative;padding:26px 20px 40px;}\r\n.hero-mobile::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background-image: url('../../../static/hero-img.webp');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  opacity: 0.35; /* Blurs/fades ONLY the image */\r\n  z-index: -1;   /* Pushes it behind the text */\r\n}\r\n.hero-mobile h1{font-size:2.4rem;line-height:1.05;color:var(--navy)}\r\n.hero-mobile p{margin:16px 0 24px;font-size:1rem}\r\n\r\n.btns-mobile{display:flex;gap:12px;flex-wrap:wrap}\r\n\r\n.hero-left{\r\n    flex:1;\r\n    text-align: center;\r\n}\r\n\r\n.hero-left h1{\r\n    font-size:60px;\r\n    line-height:1.1;\r\n    margin-bottom:20px;\r\n}\r\n\r\n.hero-left p{\r\n    font-size:20px;\r\n    margin-bottom:30px;\r\n}\r\n\r\n.hero-buttons{\r\n    display:flex;\r\n    justify-content: center;\r\n    gap:20px;\r\n}\r\n\r\na.btn{\r\n    padding:15px 35px;\r\n    border-radius:8px;\r\n    text-decoration:none;\r\n    font-weight:bold;\r\n    transition:.3s;\r\n}\r\n\r\na.btn-mobile{\r\n    padding:14px 18px;border-radius:12px;text-decoration:none;font-weight:700;text-align:center;flex:1;\r\n}\r\n\r\na.btn-primary{\r\n    background:#dc2626;\r\n    color:white;\r\n}\r\n\r\na.btn-primary:hover{\r\n    background:#b91c1c;\r\n}\r\n\r\na.btn-secondary{\r\n    border:2px solid #0f172a;\r\n    background:transparent;\r\n    color:#0f172a;\r\n}\r\n\r\na.btn-secondary:hover{\r\n    background:#0f172a;\r\n    color:white;\r\n}\r\n\r\n.hero-right{\r\n    flex:1;\r\n}\r\n\r\n.hero-right img{\r\n    width:100%;\r\n    border-radius:20px;\r\n    box-shadow:0 20px 40px rgba(0,0,0,.15);\r\n}\r\n\r\n/* SECTION */\r\n\r\nsection{\r\n    padding:40px 2%;\r\n}\r\n\r\n.section-title{\r\n    text-align:center;\r\n    font-size:clamp(1.125rem, 4vw, 1.875rem);\r\n    margin-bottom:20px;\r\n}\r\n\r\n/* COMPARISON */\r\n\r\n.comparison{\r\n    display:grid;\r\n    grid-template-columns:1fr;\r\n    gap:30px;\r\n}\r\n\r\n.comparison-section{\r\n    display:none;\r\n}\r\n\r\n.comparison-section-mobile{\r\n    display:block;\r\n}\r\n\r\n.box{\r\n    padding:40px;\r\n    border-radius:20px;\r\n    text-align:center;\r\n    overflow: hidden;\r\n}\r\n\r\n.old-way{\r\n  position: relative;\r\n}\r\n\r\n.old-way::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background-image: url('../../../static/old-way.webp');\r\n  background-size: cover;\r\n  opacity: 0.15; /* Blurs/fades ONLY the image */\r\n  z-index: -1;   /* Pushes it behind the text */\r\n}\r\n\r\n.new-way{\r\n  position: relative;\r\n}\r\n\r\n.new-way::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background-image: url('../../../static/new-way.webp');\r\n  background-size: cover;\r\n  background-position: center;\r\n  opacity: 0.35; /* Blurs/fades ONLY the image */\r\n  z-index: -1;   /* Pushes it behind the text */\r\n}\r\n\r\n.box h3{\r\n    margin-bottom:20px;\r\n    font-size:28px;\r\n}\r\n\r\n.box {\r\n    font-weight:600;\r\n}\r\n\r\n/* BENEFITS */\r\n\r\n.benefit-section{\r\n    display:none;\r\n}\r\n\r\n.cards{\r\n    display:grid;\r\n    grid-template-columns:repeat(auto-fit,minmax(250px,1fr));\r\n    gap:30px;\r\n}\r\n\r\n.card{\r\n    display: none;\r\n    background:white;\r\n    padding:40px;\r\n    border-radius:20px;\r\n    text-align:center;\r\n    box-shadow:0 10px 25px rgba(0,0,0,.08);\r\n}\r\n\r\n.card-mobile{background:#fff;border-radius:18px;padding:22px;box-shadow:0 8px 24px rgba(0,0,0,.08);margin-bottom:18px}\r\n\r\n.card h3{\r\n    margin:20px 0;\r\n}\r\n\r\n/* PROCESS */\r\n\r\n.how-it-works{\r\n    margin-bottom:10px;\r\n}\r\n.steps{\r\n    display:grid;\r\n    grid-template-columns:repeat(5,1fr);\r\n    gap:20px;\r\n}\r\n\r\n.step{\r\n    background:white;\r\n    padding:30px;\r\n    text-align:center;\r\n    border-radius:20px;\r\n    box-shadow:0 5px 15px rgba(0,0,0,.08);\r\n}\r\n\r\n.step-mobile{\r\n  display:flex;\r\n  align-items:center;\r\n  gap:16px;\r\n  margin:16px 0\r\n}\r\n\r\n.num-mobile {\r\n  width:42px;\r\n  height:42px;\r\n  border-radius:50%;\r\n  background:#d62828;\r\n  color:#fff;\r\n  display:flex;\r\n  align-items:center;\r\n  justify-content:center;\r\n  font-weight:700;\r\n}\r\n\r\n\r\n.whatsapp-section{\r\n    display:flex;\r\n    justify-content:end;\r\n    width:100%;\r\n    align-items:center;\r\n}\r\n\r\na.whatsapp-box{\r\n    position:relative;\r\n    margin-bottom:12px;\r\n    max-width:300px;\r\n    display:flex;\r\n    align-items:center;\r\n    background:#25D366;\r\n    animation: breathe 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes breathe{\r\n\r\n    0%{\r\n        transform:scale(1);\r\n        box-shadow:0 0 0 rgba(37,211,102,.4);\r\n    }\r\n\r\n    50%{\r\n        transform:scale(1.1);\r\n        box-shadow:0 12px 35px rgba(37,211,102,.45);\r\n    }\r\n\r\n    100%{\r\n        transform:scale(1);\r\n        box-shadow:0 0 0 rgba(37,211,102,.4);\r\n    }\r\n\r\n}\r\n\r\n.number{\r\n    width:60px;\r\n    height:60px;\r\n    background:#dc2626;\r\n    color:white;\r\n    border-radius:50%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    margin:0 auto 20px;\r\n    font-size:24px;\r\n    font-weight:bold;\r\n}\r\n\r\n/* INSPECTION */\r\n\r\n.inspection{\r\n    display:none;\r\n    background:#0f172a;\r\n    color:white;\r\n    border-radius:30px;\r\n    padding:30px;\r\n}\r\n\r\n.inspection-mobile{\r\n\r\n    display:flex;\r\n    flex-direction:column;\r\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 100%), url('../../../static/inspection-mobile.webp');\r\n    aspect-ratio: 3 / 4;\r\n    background-size: contain;\r\n    color:white;\r\n    padding:45px;\r\n\r\n    justify-content:space-between;\r\n    align-items:end;\r\n    gap:40px;\r\n\r\n}\r\n\r\n.inspection-mobile p{\r\n\r\n    font-size:12px;\r\n    line-height:1.8;\r\n    color:#d1d5db;\r\n\r\n}\r\n\r\n.inspection-list{\r\n    display:grid;\r\n    grid-template-columns:1fr;\r\n    gap:20px;\r\n    margin-top:40px;\r\n}\r\n\r\n.inspection-item{\r\n    background:rgba(255,255,255,.08);\r\n    padding:20px;\r\n    border-radius:10px;\r\n}\r\n\r\n/* CTA */\r\n\r\n.cta{\r\n    display:none;\r\n    background:#dc2626;\r\n    color:white;\r\n    text-align:center;\r\n    border-radius:30px;\r\n}\r\n\r\n.cta h2{\r\n    font-size:50px;\r\n    margin-bottom:20px;\r\n}\r\n\r\n/* FOOTER */\r\n\r\nfooter{\r\n    background:#0f172a;\r\n    color:white;\r\n    text-align:center;\r\n    padding:40px;\r\n    margin-top:40px;\r\n}\r\n\r\n/* MOBILE */\r\n\r\n@media(min-width:900px){\r\n  section{\r\n    padding:90px 8%;\r\n  }\r\n  .section-title{\r\n    text-align:center;\r\n    font-size:42px;\r\n    margin-bottom:40px;\r\n  }\r\n  .header{\r\n    display:flex;\r\n  }\r\n  .header-mobile{\r\n    display:none;\r\n  }\r\n  .hero{\r\n    display:flex;\r\n    min-height:90vh;\r\n    align-items:center;\r\n    justify-content:space-between;\r\n    padding:80px 8%;\r\n    gap:60px;\r\n  }\r\n  .hero-mobile{\r\n    display:none;\r\n  }\r\n  .comparison-section{\r\n    display:block;\r\n  }\r\n  .comparison-section-mobile{\r\n    display:none;\r\n  }\r\n  .comparison{\r\n    grid-template-columns:1fr 1fr;\r\n  }\r\n  .inspection-list{\r\n    grid-template-columns:repeat(2,1fr);\r\n  }\r\n  .benefit-section{\r\n    display:block;\r\n  }\r\n  .benefit-section-mobile{\r\n    display:none;\r\n  }\r\n  .card{\r\n    display:block;\r\n  }\r\n  .card-mobile{\r\n    display:none;\r\n  }\r\n  .inspection{\r\n    display:block;\r\n  }\r\n  .inspection-mobile{\r\n    display:none;\r\n  }\r\n  .cta{\r\n    display:block\r\n  }\r\n  footer{\r\n    margin-top:80px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
